import * as React from "react";

function ResetIcon(props) {
  return (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx={15.9961}
      cy={16.2385}
      rx={1.66383}
      ry={1.69923}
      transform="rotate(-90 15.9961 16.2385)"
      fill="#474747"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2178 9.09723L13.6891 8.40503L16.0023 9.91504L18.3155 8.40503L18.7868 9.09723L16.0023 10.9149L13.2178 9.09723Z"
      fill="#474747"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7822 23.3795L18.3109 24.0717L15.9977 22.5617L13.6845 24.0717L13.2132 23.3795L15.9977 21.5619L18.7822 23.3795Z"
      fill="#474747"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.70692 18.9649L8 18.5034L9.54214 16.2384L8 13.9734L8.70692 13.5119L10.5633 16.2384L8.70692 18.9649Z"
      fill="#474747"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.2931 13.5123L24 13.9737L22.4579 16.2387L24 18.5038L23.2931 18.9652L21.4367 16.2387L23.2931 13.5123Z"
      fill="#474747"
    />
  </svg>
  );
}

export default ResetIcon;
